import 'uni-pages';
import Vue from 'vue'
import Page from './demo/pages/mall/newOrder.vue'
createPage(Page)